import { useContext } from 'react';
import { AppContext } from '@blaze-cms/nextjs-components';
const EVENET_PREFIX = 'plugin:page-builder:';
const EVENET_SUFIX = ':sync';
const useAppSyncEventHook = ({
  eventName,
  data,
  props
}) => {
  const {
    blazeApp
  } = useContext(AppContext);
  if (!blazeApp) return {
    data
  };
  blazeApp.events.emit(`${EVENET_PREFIX}${eventName}${EVENET_SUFIX}`, {
    data,
    props
  });
  return {
    data
  };
};
export default useAppSyncEventHook;
//# sourceMappingURL=use-app-sync-event-hook.js.map